<template>
  <i-modal :title="LANG.publishStatus">
    <ModalPublishStatusContent :nodeId="document.nodeId"/>

    <template #footer>
      <div>
        <i-button variant="secondary" @click="$emit('update:show', false)">{{ LANG.cancel }}</i-button>
      </div>
    </template>
  </i-modal>
</template>

<script>
import { mapState } from 'vuex';
import ModalPublishStatusContent from './ModalPublishStatusContent.vue';

export default {
  components: {
    ModalPublishStatusContent,
  },
  props: {
    document: {
      default: () => ({}),
      type: Object,
    },
  },
  data() {
    return { };
  },
  computed: {
    ...mapState(['LANG']),
  },
};
</script>
